import FormModule from './FormContainer';
import {isMobile} from 'Utils/device';

let FormModuleFn = (isMobile)? null: FormModule;

export default FormModuleFn;